import React from 'react';
import ReactPlayer from "react-player"
 

import './Paginator.css';

const paginator = props => (
  <div className="paginator">
    {props.children}
    <div className="paginator__controls">
      {props.currentPage > 1 && (
        <button className="paginator__control" onClick={props.onPrevious}>
          Previous
        </button>
      )}
      {props.currentPage < props.lastPage && (
        <button className="paginator__control" onClick={props.onNext}>
          Next
        </button>
      )}
    </div>
    <div>
      <br/>
      <ReactPlayer
        playing url='https://alexadreamachiever.s3-eu-west-1.amazonaws.com/website/Particle.mp4'
        loop={true}
        playsInline
        onReady
        playing
        className="video"
        controls = {true}
      />
    </div>
  </div>
);

export default paginator;
